import { useContext, useState } from "react";
import {
	MenuItem,
	Select,
	SelectChangeEvent,
	Stack,
	Typography,
	styled,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import * as React from "react";
import { ES, PT, US } from "country-flag-icons/react/3x2";
import { LangContext } from "../../types/internationalization";

const LangStack = styled(Stack)(() => ({
	justifyContent: "center",
	alignItems: "center",
}));

const LangTypography = styled(Typography)(() => ({
	fontFamily: "Noto Sans Gujarati, sans-serif",
	fontWeight: "400",
}));

//This is a Language Select
export const LangSelect: React.FC = () => {
	const langContext = useContext(LangContext);
	const [tempLang, setTempLang] = useState("es-ES"); // Este State no es necesario, pero MUI lo usa para actualizar su prop "value".

	//When the language changes, we call the onLanguageChange from lang context, so it changes the language
	//in all the application
	const handleLanguageChange = (event: SelectChangeEvent) => {
		const newLang = event.target.value as string;
		setTempLang(newLang);
		langContext!.onLanguageChange(newLang);
	};

	return (
		<Select
			value={tempLang}
			onChange={handleLanguageChange}
			variant="standard"
			IconComponent={ExpandMoreIcon}
			sx={styles}
		>
			<MenuItem dense value={"es-ES"}>
				<LangStack direction="row" spacing={1}>
					<ES title="Spain" width="16px" height="16px" />
					<LangTypography>ES</LangTypography>
				</LangStack>
			</MenuItem>
			<MenuItem dense value={"en-US"}>
				<LangStack direction="row" spacing={1}>
					<US title="United States" width="16px" height="16px" />
					<LangTypography>EN</LangTypography>
				</LangStack>
			</MenuItem>
			<MenuItem dense value={"pt-BR"}>
				<LangStack direction="row" spacing={1}>
					<PT title="Portugal" width="16px" height="16px" />
					<LangTypography>PT</LangTypography>
				</LangStack>
			</MenuItem>
		</Select>
	);
};

const styles = {
	justifyContent: "center",
	alignItems: "center",
	"&.MuiInput-root::before": {
		borderBottom: "none",
	},
	"&.MuiInput-root::after": {
		borderBottom: "none",
	},
	"&:hover": {
		"&.MuiInput-root::before": {
			borderBottom: "none",
		},
		"&.MuiInput-root::after": {
			borderBottom: "none",
		},
	},
};
